import DataTable from "../../Reusable/DataTable/FleetDataTable";
import NACell from "../../Reusable/DataTable/NACell";
import APIS from "../../../constant/EndPoint";
import TableActionButton from "../../Reusable/TableActionButton";

const VehicleList = () => {

  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Emergency Contact Number",
      accessorKey: "emergency_contact_number",
      cell: NACell,
    },

    {
      header: "License Number",
      accessorKey: "license_number",
      cell: NACell,
    },

    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },
  ];
  return (
    <DataTable
      url={APIS.VEHILCE}
      queryKey={"vehicle-type"}
      columns={defaultColumns}
      addNewPagePath={"/create-vehicle"}
      tableName={"Vehicle Type"}
    />
  );
};

export default VehicleList;
